@if (loading) {
  <div class="loading-indicator">
    <p-progressSpinner></p-progressSpinner>
  </div>
}
<div class="rtnav ui-g">
  <div class="ui-g-8 msgbox-6">
    @for (message of msgsEngDetails; track message) {
      <p-message [life]="3000" [text]="message.detail"></p-message>
    }
  </div>
  @if (!btnNavEngDetails) {
    <div class="ui-g-3"></div>
  }
  @if (btnNavEngDetails) {
    <div class="ui-g-3">
      <button
        type="button"
        pButton
        (click)="editIncentiveDetailsCancel()"
        class="ui-button-secondary flat fl-rt">
        Cancel
      </button>
      <button
        type="submit"
        pButton
        (click)="onSubmitIncentiveDetails(formIncentiveDetails)"
        class="flat btnmr fl-rt">
        Save
      </button>
    </div>
  }
  <div class="ui-g-1 edit-history-icon">
    <span
      class="fa fa-pencil ico cpointer fl-rt"
      pTooltip="Edit"
      (click)="editIncentiveDetails()"
      (keydown.enter)="editIncentiveDetails()"
      tabindex="0"
      tooltipPosition="bottom"></span>
  </div>
</div>
<form [formGroup]="formIncentiveDetails" #localForm="ngForm">
  <div class="readonlytbox incentive-details">
    <div class="ui-g">
      <div class="ui-g-12 ui-md-4 ui-lg-4">Qualified Amount</div>
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        <input
          type="text"
          pInputText
          [readonly]="isReadonlyEng"
          (keypress)="numberOnly($event)"
          formControlName="qualifiedAmount" />
      </div>
      <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
    </div>
    <div class="ui-g">
      <div class="ui-g-12 ui-md-4 ui-lg-4">Task Owner</div>
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        <p-select
          [options]="taskOwnerDrpdwn"
          [readonly]="isReadonlyEng"
          formControlName="taskOwner"
          [class.readonlydd]="isReadonlyEng === true"
          placeholder="--SELECT--"
          optionLabel="taskOwner"></p-select>
      </div>
      <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
    </div>
    <div class="ui-g">
      <div class="ui-g-12 ui-md-4 ui-lg-4">PMO Next Steps</div>
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        <p-select
          [options]="pmoNextStepDrpdwn"
          [readonly]="isReadonlyEng"
          formControlName="ddpmoNextSteps"
          [class.readonlydd]="isReadonlyEng === true"
          placeholder="--SELECT--"
          optionLabel="pmoNextStepName"></p-select>
      </div>
      <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
    </div>
    <div class="ui-g">
      <div class="ui-g-12 ui-md-4 ui-lg-4">L1 Internal Status</div>
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        <p-select
          [options]="l1InternalStatus1"
          [readonly]="isReadonlyEng"
          formControlName="t1InternalStatus"
          [class.readonlydd]="isReadonlyEng === true"
          placeholder="--SELECT--"
          optionLabel="l1internalStatus"></p-select>
      </div>
      <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
    </div>
    <div class="ui-g">
      <div class="ui-g-12 ui-md-4 ui-lg-4">Ops Status</div>
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        <p-select
          [options]="l2InternalStatus1"
          [readonly]="isReadonlyEng"
          formControlName="opsStatus"
          [class.readonlydd]="isReadonlyEng === true"
          placeholder="--SELECT--"
          optionLabel="l2internalStatus"></p-select>
      </div>
      <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
    </div>
    <div class="ui-g">
      <div class="ui-g-12 ui-md-4 ui-lg-4">Decline Reasons</div>
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        <p-select
          [options]="declineReason"
          [readonly]="isReadonlyEng"
          formControlName="declineReasons"
          [class.readonlydd]="isReadonlyEng === true"
          placeholder="--SELECT--"
          optionLabel="declineReason"></p-select>
      </div>
      <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
    </div>
    <div class="ui-g">
      <div class="ui-g-12 ui-md-12 ui-lg-12">
        <div class="hdbl">Key Dates</div>
      </div>
    </div>
    @if (!isMCIWorkshop) {
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Requested Date</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <p-datepicker
            formControlName="requestDate"
            dateFormat="mm/dd/yy"
            placeholder="mm/dd/yy"
            [readonlyInput]="true"
            [defaultDate]="maxYearDate"
            [showOnFocus]="false"
            [iconDisplay]="'input'"
            [showIcon]="true"
            [class.readonlycaltb]="false">
          </p-datepicker>
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
    }
    @if (!isMCIWorkshop) {
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">45 day Expiration Date</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <p-datepicker
            formControlName="day45ExpirationDate"
            dateFormat="mm/dd/yy"
            placeholder="mm/dd/yy"
            [readonlyInput]="true"
            [defaultDate]="maxYearDate"
            [showOnFocus]="false"
            [iconDisplay]="'input'"
            [showIcon]="true"
            [class.readonlycaltb]="isReadonlyEng === true">
          </p-datepicker>
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
    }
    @if (!isMCIWorkshop) {
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          Days Left From 45 Days Expiration Date
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            (keypress)="numberOnly($event)"
            readonly
            formControlName="daysLeftFromDay45ExpirationDate" />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
    }
    <div class="ui-g">
      <div class="ui-g-12 ui-md-4 ui-lg-4">Incentive Expiration Date</div>
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        <input
          type="text"
          pInputText
          (keypress)="numberOnly($event)"
          readonly
          formControlName="expirationDate" />
      </div>
      <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
    </div>
    <div class="ui-g">
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        Days left from Incentive Expiration Date
      </div>
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        <input
          type="text"
          pInputText
          (keypress)="numberOnly($event)"
          readonly
          formControlName="daysLeftFromExpirationDate" />
      </div>
      <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
    </div>
    <div class="ui-g">
      <div class="ui-g-12 ui-md-4 ui-lg-4">Date Incentive Cancelled</div>
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        <input
          formControlName="cancelledDate"
          readonly
          [class.readonlydd]="isReadonlyEng === true"
          type="text"
          pInputText />
      </div>
      <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
    </div>
    <div class="ui-g">
      <div class="ui-g-12 ui-md-4 ui-lg-4">Funding Type</div>
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        <input
          formControlName="fundingType"
          readonly
          [class.readonlydd]="isReadonlyEng === true"
          type="text"
          pInputText />
      </div>
      <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
    </div>
  </div>
</form>
